import Vue from 'vue'
import VueRouter from 'vue-router'
import api from "@/api"
import store from './store'

import Auth from './views/Auth.vue'
import Profile from './views/Profile.vue'
import Home from './views/Home'
import Admin from './views/Admin'
import Validate from './views/Validate'
import LinkedInWaiting from './components/auth/sso/LinkedInWrap.vue'
import CsvLogin from './components/auth/CsvLogin.vue'
import ResubmitPoll from './views/ResubmitPollForm'
import Agenda from './views/Agenda'
import ReportedMessages from './views/admin-pages/ReportedMessages'
import ReportedUsers from './views/admin-pages/ReportedUsers'
import AdminApproval from './views/admin-pages/Approval'
import AdminLinks from './views/admin-pages/Links'
import AdminLogin from './views/admin-pages/AdminLogin'
import AdminVideo from './views/admin-pages/VideoUpload'
import AddUsers from './views/admin-pages/AddUsers'
import AdminAgenda from './views/admin-pages/AdminAgenda'
import AdminTag from "./views/admin-pages/Tag"
import AdminCompany from "./views/admin-pages/Company"
import UserManagement from './views/admin-pages/UserManagement'
import Templates from './views/admin-pages/Templates'
import FairManagement from './views/admin-pages/FairManagement'
import editPolls from './views/admin-pages/PollManagement'
import PollManagerParent from './views/admin-pages/PollManagerParent'
import CsvUpload from './views/admin-pages/CsvUpload'
import SuperAdmin from './views/admin-pages/SuperAdmin'
import FairConfig from './views/admin-pages/FairConfig'
import SideMenus from './views/admin-pages/SideMenus'
import Permissions from './views/admin-pages/Permissions'
import Conference from './views/Conference'
import InfoBooth from './views/InfoBooth'
import Booth from './views/Booth'
import Floor from './views/Floor'
import ListOfAttendees from './views/ListOfAttendees'
import Help from './views/Help'
import MessageCenter from './views/admin-pages/MessageCenter'
import Tracking from './views/admin-pages/Tracking'
import ProfilePicFrames from './views/admin-pages/ProfilePicFrames'
import AdminBadges from './views/admin-pages/AdminBadges'
import i18n from './i18n'
import EventBus from './js/eventBus'
import Accessibility from './views/admin-pages/Accessibility'
import DynamicFooter from './views/admin-pages/DynamicFooter'
import newTags from './views/admin-pages/NewTags'
import CssImport from './views/admin-pages/CssImport'
import Terms from './views/Terms.vue'
import Privacy from './views/Privacy.vue'
import { getFairConfig, checkSession, getPermissions, getPublicPermissions } from './js/routerHelpers.js'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Home,
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true
        },
    },
    {
        path: '/linkedin',
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: false
        },
        component: LinkedInWaiting
    },
    {
        path: '/csv-login',
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: false
        },
        component: CsvLogin,
        beforeEnter: (to, from, next) => {
            if (to.query.token && to.query.usrid) next();
            else next('/login');
        }
    },
    {
        path: '/admin/login',
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: false
        },
        component: AdminLogin
    },
    {
        path: '/:action(login|register|forgotpassword|resetpassword)',
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: true
        },
        beforeEnter: async (to, from, next) => {
            const isLoginDisabled = Number(store.state.fairConfig.FC_LOGREG) ? false : true;
            if (store.state.isLoggedIn || isLoginDisabled) {
                next('/')
            } else {
                next()
            }
        },
        component: Auth
    },
    {
        path: '/validate',
        name: 'Validate',
        meta: {
            sidebar: false,
            requiresLogin: false,
            footer: false
        },
        beforeEnter: async (to, from, next) => {
            const isLoginDisabled = Number(store.state.fairConfig.FC_LOGREG) ? false : true;
            if (isLoginDisabled) {
                next('/')
            }
            if (
                (from.path === '/register' || from.path === '/login') ||
                (to.query.token && to.query.usrid || to.query.q === 'true') ||
                (to.query.sso === 'linkedin' || to.query.sso === 'google')
            ) {
                next()
            } else {
                next(from)
            }
        },
        component: Validate
    },
    {
        path: '/live/:id',
        meta: {
            sidebar: true,
            requiresLogin: true,
            footer: true,
        },
        component: Conference,
        async beforeEnter(to, from, next) {
            let loc_id = to.params.id
            if (await api.checkPermission({ loc_id })) next()
            else {
                EventBus.$emit('error', i18n.messages[i18n.locale].noPermission)
                next(from.path)
            }
        }
        
    },
    {
        path: '/info-booth',
        meta: {
            sidebar: true,
            requiresLogin: true,
            footer: true
        },
        component: InfoBooth
    },
    {
        path: '/profile/',
        name: 'Profile',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true
        },
        component: Profile
    },
    {
        path: '/profile/:name-:lastname-:profile_id',
        name: 'ProfileId',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true,
            permissions: ['user_profile_view']
        },
        component: Profile
    },
    {
        path: '/admin/login',
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: false
        },
        component: AdminLogin
    },
    {
        path: '/admin',
        redirect: '/admin/report/messages',
        meta: {
            requiresAdmin: true,
            sidebar: false,
            permissions: ['admin_access']
        },
        component: Admin,
        children: [
            {
                path: 'report/messages',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_reported'],
                    value: i18n.messages[i18n.locale].adminNav.messages,
                    indented: true
                },
                name: 'adminReportedMessages',
                component: ReportedMessages
            },
            {
                path: 'report/users',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_reported'],
                    value: i18n.messages[i18n.locale].adminNav.users,
                    indented: true
                },
                name: 'adminReportedUsers',
                component: ReportedUsers
            },
            {
                path: 'approval',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_validate'],
                    value: i18n.messages[i18n.locale].adminNav.approval
                },
                name: 'adminApproval',
                component: AdminApproval
            },
            {
                path: 'links',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_streaming_links'],
                    value: i18n.messages[i18n.locale].adminNav.streamingLinks
                },
                name: 'adminLinks',
                component: AdminLinks
            },
            {
                path: 'video',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_videos_upload'],
                    value: i18n.messages[i18n.locale].adminNav.video
                },
                name: 'adminVideo',
                component: AdminVideo
            },
            {
                path: 'add-users',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_add_users'],
                    value: i18n.messages[i18n.locale].adminNav.addUsers
                },
                name: 'adminAddUsers',
                component: AddUsers
            },
            {
                path: 'agenda-management',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_agenda_edit'],
                    value: i18n.messages[i18n.locale].adminNav.agendaManagement
                },
                name: 'adminAgenda',
                component: AdminAgenda
            },
            {
                path: "company-management",
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_companies'],
                    value: i18n.messages[i18n.locale].adminNav.companies
                },
                name: "adminCompany",
                component: AdminCompany,
            },
            {
                path: 'user-management',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_user_menagement'],
                    value: i18n.messages[i18n.locale].adminNav.userManagement
                },
                name: 'adminUserManagement',
                component: UserManagement
            },
            {
                path: 'templates',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    value: i18n.messages[i18n.locale].adminNav.templates,
                    permissions: ['admin_templates']
                },
                name: 'adminTemplates',
                component: Templates
            },
            {
                path: 'fair-management',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    value: i18n.messages[i18n.locale].adminNav.fairManagement,
                    permissions: ['admin_fair_management']
                },
                name: 'adminFairManagement',
                component: FairManagement
            },
            {
                path: 'polls',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_poll_management'],
                    value: i18n.messages[i18n.locale].adminNav.polls
                },
                name: 'adminPolls',
                component: PollManagerParent
            },
            {
                path: 'editPolls/:id',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_poll_management'],
                },
                name: 'editPolls',
                component: editPolls
            },
            {
                path: 'tracking',
                name: 'tracking',
                component: Tracking,
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_user_tracking'],
                    value: i18n.messages[i18n.locale].adminNav.tracking
                },
            },
            {
                path: 'message-center',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_message_center'],
                    value: i18n.messages[i18n.locale].adminNav.messageCenter
                },
                name: 'messageCenter',
                component: MessageCenter
            },
            {
                path: 'profile-picture-frame-manager',
                name: 'profilePictureFrameManager',
                component: ProfilePicFrames,
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_profile_picture_frame'],
                    value: i18n.messages[i18n.locale].adminNav.profilePicFrameManager
                },
            },
            {
                path: 'csv',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_csv'],
                    value: i18n.messages[i18n.locale].adminNav.csv
                },
                name: 'adminCsv',
                component: CsvUpload
            },
            {
                path: 'super-admin',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_super_admin'],
                    value: i18n.messages[i18n.locale].adminNav.superAdmin
                },
                name: 'adminSuperAdmin',
                component: SuperAdmin
            },
            {
                path: 'fair-config',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_fair_configs'],
                    value: i18n.messages[i18n.locale].adminNav.fairConfig
                },
                name: 'adminFairConfig',
                component: FairConfig
            },
            {
                path: 'side-menus',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_side_menu'],
                    value: i18n.messages[i18n.locale].adminNav.sideMenus
                },
                name: 'adminSideMenus',
                component: SideMenus
            },
            {
                path: 'accessibility',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_accessibility'],
                    value: i18n.messages[i18n.locale].adminNav.accessibility
                },
                name: 'accessibility',
                component: Accessibility
            },
            {
                path: 'edit-permissions',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_permissions'],
                    value: i18n.messages[i18n.locale].adminNav.adminPermissions
                },
                name: 'adminPermissions',
                component: Permissions
            },
            {
                path: 'badges',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions:['admin_badges'],
                    value: i18n.messages[i18n.locale].adminNav.badges
                },
                name: 'adminBadges',
                component: AdminBadges
            },
            {
                path: 'dynamicfooter',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    value: i18n.messages[i18n.locale].adminNav.footer
                },
                name: 'dynamicFooter',
                component: DynamicFooter
            },
            {
                path: 'newtags',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    permissions: ['admin_tags'],    
                    value: i18n.messages[i18n.locale].adminNav.tags
                },
                name: 'newTags',
                component: newTags
            },
            {
                path: 'import-css',
                meta: {
                    requiresAdmin: true,
                    sidebar: false,
                    // permissions: [],
                    value: i18n.messages[i18n.locale].adminNav.importCss
                },
                name: 'importCss',
                component: CssImport
            }
        ]
    },
    /* Nove rute */
    {
        path: "/member-directory",
        meta: {
            requiresLogin: false,
            sidebar: false,
            footer: false,
        }
    },
    {
        path: '/agenda',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true,
        },
        component: Agenda,
    },
    {
        path: '/floor/:floor',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true,
        },
        component: Floor,
        async beforeEnter(to, from, next) {
            let loc_id = to.params.floor
            if (await api.checkPermission({ loc_id })) next()
            else {
                EventBus.$emit('error', i18n.messages[i18n.locale].noPermission)
                next(from.path)
            }
        }
    },
    {
        path: '/booth/:booth',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true
        },
        component: Booth,
        async beforeEnter(to, from, next) {
            let name = to.params.booth
            let allLocations = await api.getAgendaLocations()
            let loc_id = allLocations.data.result.map(el => {
                if (el.ltp_code === 'bth' && el.loc_name == name) return el
            }).filter(el => el)[0].loc_id
            if (await api.checkPermission({ loc_id })) next()
            else {
                EventBus.$emit('error', i18n.messages[i18n.locale].noPermission)
                next(from.path)
            }
        }
    },
    {
        path: '/help',
        meta: {
            requiresLogin: true,
            sidebar: true
        },
        component: Help
    },
    {
        path: '/list-of-attendees',
        meta: {
            requiresLogin: true,
            sidebar: true,
            footer: true
        },
        name: "listOfAttendees",
        component: ListOfAttendees,
        beforeEnter: async (to, from, next) => {
            if (store.state.fairConfig.FC_LISTUSERS == 1) next()
        }
    },
    {
        path: '/privacy',
        meta: {
            requiresLogin: false,
            sidebar: true,
            footer: true
        },
        name: 'privacy',
        component: Privacy
    },
    {
        path: '/terms-and-conditions',
        meta: {
            requiresLogin: false,
            sidebar: true,
            footer: true
        },
        name: "terms",
        component: Terms
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    console.log('ovo je general beforeEach');
    // save
    console.log('each');
    let s = () => {
        store.dispatch('saveHistoryNavigation', from.path);
    }

    // get fairConfig and state only if its not called before
    if (Object.keys(store.state.fairConfig).length === 0) {
        await getFairConfig();
        await checkSession();
    }
    

    // start of permissions logic
    // api is called only when no permissions are fetched earlier AND the user is logged in AND the fair is not public
    // (should be once per app visit)
    // if the fair is public, everything is visible
    // if the user is logged out:
    // user sees only features that require no permissions OR user sees everything (public fair)
    if (!store.state.permissions && store.state.isLoggedIn && store.state.fairConfig.FC_PUBLIC == 0) {
        await getPermissions();
    }
    if (!store.state.publicPermissions && store.state.fairConfig.FC_PUBLIC == 1) {
        await getPublicPermissions();
    }

    const userPermissions = store.state.isLoggedIn? store.state.permissions : store.state.publicPermissions;

    if (to.meta.permissions && userPermissions) {
        if (to.meta.permissions.some(perm => userPermissions.includes(perm))) {
            s();
            next();
            return;
        } else {
            s();
            next(from.path);
            return;
        }
    }
    // end of permissions logic

    // first we check if it has any meta tags, if not its good to go
    if (!to.meta.requiresLogin && !to.meta.requiresAdmin && !to.meta.requiresLoginEvenIfPublic) {
        s();
        next()
        return
    }
    // after, we check if it is necessary to be logged in even if public
    if (to.meta.requiresLoginEvenIfPublic) {
        if (localStorage.getItem('sid')) {
            s();
            next()
            return;
        }
        else {
            s();
            next('/login');
            return;
        }
    }
    // after, we check if it requires login
    if (to.meta.requiresLogin) {
        console.log('ulazi ovde?');
        // we check if fair is public
        if (localStorage.getItem('public')) {
            s();
            next();
            return;
        }
        // we check if we are logged in
        else if (localStorage.getItem('sid')) {
            s();
            next();
            return;
        }
        // otherwise push to login
        else {
            s();
            next('/login');
            return;
        }
    }
    // after, we check if it requires admin login
    if (to.meta.requiresAdmin) {
        if (store.state.isAdmin || localStorage.getItem('isAdmin')) {
            s();
            next();
            return;
        } else {
            s();
            next('/admin/login');
            return;
        }
    }
    console.log('Router guard did not resolve, navigation canceled');
    console.log(to.meta);
})


export default router
